<template>
	<div>
		<div class="info-flow-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="cancelPayModal" aria-hidden="true">
			<div class="modal-dialog modal-pdv">
				<div class="modal-content">
					<div class="modal-title">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<img src="/images/featured/close-circle-menu.svg" alt="close-circle-menu" /> 
						</button>
					</div>
					<div class="d-flex justify-content-center mt-4">
						<img src="/images/featured/IconButton.svg" alt="IconButton" />
					</div>
					<div class="main-content w-full">
						<div class="row w-full">
							<div class="col text-content w-full">
								<div class="text-content-div">
									<h5>{{ title  }}</h5><br>
									<h6>{{  despcription  }}</h6>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-center">
						<Button 
							title="Entendido"
							type="secundario"
							size="medium"
							@onClick="onContinue"
							data-dismiss="modal" aria-label="Close"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import Button from "@/components/featured/Button";
	export default {
		data(){
			return {

			}
		},
		props: {
			title: '',
			despcription: ''
		},
		components: {
			Button
		},
		methods:{
			onContinue(){
				this.$emit('onContinue')
			},
		}
	}
</script>

<style scoped lang="scss">

	.row{
		margin-right: 0 !important;
    margin-left: 0 !important;
	}
	.info-flow-modal{
		margin-top: 100px ;
			@include media-breakpoint-down(sm){
					padding-right: 0 !important;
			}
			.modal-pdv{
					width: 40%;
					@include media-breakpoint-down(sm){
							margin: 65px 20px 0px 20px;
					}
					.modal-content{
						border-radius: 24px;
							border: 2px solid $neutralBlack;
							background: $neutralwhite;
							padding: 24px;
							box-shadow: 0 0 12px 3px #00000038;
							h5 {
								color: #592466;
								text-align: center;
								font-family: 'Poppins-Bold', sans-serif;
								font-size: 32px;
								font-style: normal;
								font-weight: 700;
								line-height: 42px;
								margin-bottom: 10px;
							}
							h6 {
								color: $neutralBlack;
								text-align: center;
								font-family: 'Poppins-Regular', sans-serif;
								font-size: 16px;
								font-style: normal;
								font-weight: 400;
								line-height: 24px;
								margin-bottom: 0px;
							}
							ul {
									margin-top: 5px;
									margin-bottom: 15px;
									li {
											color : #DC3545;
											font-weight: bold;
									}
							}
							.modal-title{
									button.close{
											position: absolute;
											right: 15px;
											top: 15px;
											opacity: 1;
											span{
													font-size: 30px;
													color: $brown-light;
											}
									}
							}
							.main-content{
									display: flex;
									margin-bottom: 40px;
									h3{
											font-size: 20px;
											line-height: 23px;
											@include alternative-bold;
									}
									p {
											font-size: 18px;
											line-height: 26px;
											@include alternative-regular;
											margin-bottom: 19px;
									}
									.text-content {
											display: flex;
											align-items: center;
											img{
													margin-right: 30px;
													width: 203px;
											}
											img.clock{
													width: auto;
													margin-right: 6px;
													transform : scale(0.6)
											}
											span {
													font-size : 14px;
											}
											@include media-breakpoint-down(sm){
													display: block;
													text-align: center;
													img{
															margin-right: 0;
															margin-bottom: 18px;
															width: 146px;
													}
											}
										
											.text-content-div{
												display: flex;
												flex-direction: column;
												align-items: center;
												h5, h6{
													text-align: center;
												}
											}
									}
									.button {
											 @include media-breakpoint-up(sm){
													 width:160px;
											}
									}
							}

					}

			}
	}
</style>